import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Box, CircularProgress, Typography } from '@mui/material';
import { applicationApi } from '../api/application';
import ApplicationSettingsPage from './ApplicationSettingsPage';
import ApplicationSetupPage from './ApplicationSetupPage';

const MyApplication: React.FC = () => {
  const { data: myApp, isLoading, error } = useQuery({
    queryKey: ['myApplication'],
    queryFn: applicationApi.getMyApplication,
  });

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <Typography color="error">
          アプリケーション情報の読み込みに失敗しました
        </Typography>
      </Box>
    );
  }

  // アプリケーション未作成の場合は初回セットアップ
  if (!myApp) {
    return <ApplicationSetupPage />;
  }

  // 作成済みの場合は設定画面
  return <ApplicationSettingsPage application={myApp} />;
};

export default MyApplication;